/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_VisualInputs */

const cs_blog_editor_visual = /** @type {(inputs: Blog_Editor_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizuální`)
};

const en_blog_editor_visual = /** @type {(inputs: Blog_Editor_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visual`)
};

/**
* | output |
* | --- |
* | "Visual" |
*
* @param {Blog_Editor_VisualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_visual = /** @type {((inputs?: Blog_Editor_VisualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_VisualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_visual(inputs)
	return cs_blog_editor_visual(inputs)
});